import DoubleSlider from './_DoubleSlider.js';
import { jsx } from 'react/jsx-runtime';
import useGlobals from '../../hooks/useGlobals.js';

var MIN_TIME = 0;
var MAX_TIME = 24;
var twoDigitsFormatter = function twoDigitsFormatter(value) {
  return "0".concat(value).slice(-2);
};
var timeFormatter = function timeFormatter(value, siteId) {
  if (value === 24) {
    return '23:59';
  }
  switch (siteId) {
    case 1:
    case 3:
    case 11:
    case 18:
      return "".concat(twoDigitsFormatter(value), ":00");
    case 15:
      return "".concat(value, ":00");
    default:
      return "".concat(twoDigitsFormatter(value), ":00");
  }
};
var TimeSlider = function TimeSlider(_ref) {
  var uniqueId = _ref.uniqueId,
    lowValue = _ref.lowValue,
    highValue = _ref.highValue,
    step = _ref.step,
    separationLimit = _ref.separationLimit,
    onChangeComplete = _ref.onChangeComplete,
    filterSliderToLabel = _ref.filterSliderToLabel,
    hidden = _ref.hidden;
  var _useGlobals = useGlobals(),
    siteId = _useGlobals.siteId;
  if (typeof onChangeComplete !== 'function' || typeof lowValue !== 'number' || typeof highValue !== 'number' || typeof lowValue === 'number' && typeof highValue === 'number' && highValue <= lowValue) {
    return false;
  }
  return /*#__PURE__*/jsx(DoubleSlider, {
    uniqueId: uniqueId,
    min: MIN_TIME,
    max: MAX_TIME,
    step: step,
    lowValue: lowValue,
    highValue: highValue,
    separationLimit: separationLimit,
    format: function format(v) {
      return timeFormatter(v, siteId);
    },
    filterSliderToLabel: filterSliderToLabel,
    onChangeComplete: onChangeComplete,
    hidden: hidden
  });
};
TimeSlider.defaultProps = {
  uniqueId: '',
  filterSliderToLabel: null,
  lowValue: 2,
  highValue: 10,
  step: 1,
  separationLimit: 1,
  hidden: false
};
var TimeSlider$1 = TimeSlider;

export { TimeSlider$1 as default };
//# sourceMappingURL=TimeSlider.js.map
